import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { reduxForm } from 'redux-form';
import classNames from 'classnames';
import InputText from '../input-text';
import { TextEditor, TextEditorMediaButtons } from '../styled-text-editor';
import CurrentUserAvatar from '../../containers/current-user-avatar';
import MoreButton from '../more-button';
import PostCreateActions from '../../containers/post-create-actions';
import Button from '../../components/button';
import CurrentUserProfileLink from '../../containers/current-user-profile-link';
import withTranslate from '../../hoc/with-translate';
import withDeviceType from '../../hoc/with-device-type';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import withAuth from '../../hoc/with-auth';
import postFormSettings from '../../services/post-form-settings';
import { isModified } from '../../services/post-form-utils';
import styles from './post-form.scss';

export class PostForm extends Component {
  state = {};

  componentWillReceiveProps({ submitting, handleSubmit }) {
    if (submitting && !this.props.submitting) {
      handleSubmit();
    }
  }

  handleDrop = event => event.preventDefault();

  handleCancelClick = () => {
    this.props.onCancel(isModified(this.props.fields, this.state.initialContent));
  };

  handleContentChange = contentState => {
    // persist initial state to test for isModified on edit discard
    this.props.fields.content.onChange(contentState);
    this.setState({
      initialContent: this.state.initialContent || contentState,
    });
  };

  renderMoreButton() {
    const { postId, categoryId } = this.props;
    if (!postId) {
      return (
        <MoreButton className={styles.moreButton}>
          <PostCreateActions categoryId={categoryId}/>
        </MoreButton>
      );
    }
  }

  renderAvatar() {
    const { isMobile } = this.props;
    return (
      <CurrentUserProfileLink>
        <CurrentUserAvatar type={isMobile ? null : CurrentUserAvatar.LARGE}/>
      </CurrentUserProfileLink>
    );
  }

  render() {
    const {
      fields: { title, content },
      limit,
      postId,
      onSubmitButtonClick: handleSubmitButtonClick,
      submitting,
      invalid,
      t,
      borderWidth,
      contentFontClassName,
      titleFontClassName,
      errors,
      isDesktop,
      forPublicUser,
    } = this.props;

    const { value: titleValue, onChange: onTitleChange } = title;
    const containerClassName = classNames(
      styles.form,
      'forum-text-color',
      'forum-card-background-color',
      'forum-card-border-color',
      contentFontClassName
    );
    const isButtonDisabled = submitting || invalid;
    let buttonTooltipText;

    if (errors.title && errors.content) {
      buttonTooltipText = t('post-form.require-fields');
    } else if (errors.title) {
      buttonTooltipText = t('post-form.require-title');
    } else if (errors.content) {
      buttonTooltipText = errors.content === 'required' ? t('post-form.require-content') : t('post-form.uploading');
    }

    return (
      <div className={containerClassName} style={{ borderWidth }}>
        <div className={styles.wrapper}>
          <div className={styles.mainArea}>
            <div className={styles.header}>
              {this.renderAvatar()}
              {/*{this.renderMoreButton()}*/}
            </div>

            <div className={styles.titleInputWrapper}>
              <InputText
                value={titleValue}
                onChange={onTitleChange}
                containerClassName={titleFontClassName}
                className={classNames(styles.titleInput, 'forum-text-color')}
                maxLength={limit}
                placeholder={t('post-form.give-this-post-a-title')}
                autoFocus={!postId || isDesktop}
                onDrop={this.handleDrop}
                data-hook="post-form__title-input"
              />
            </div>

            <div className={classNames(styles.content, 'post-form__text-editor')}>
              <TextEditor
                placeholder={t('text-editor.placeholder')}
                identifier="post"
                {...content}
                onChange={this.handleContentChange}
              />
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.editorControls}>
              <TextEditorMediaButtons identifier="post"/>
            </div>
            <div className={styles.buttons}>
              <span className={styles.button}>
                <Button isSecondary onClick={this.handleCancelClick}>
                  {t('post-form.cancel')}
                </Button>
              </span>
              <span className={styles.button}>
                <Button
                  onClick={!isButtonDisabled && forPublicUser(handleSubmitButtonClick)}
                  tooltipText={buttonTooltipText}
                  isMuted={isButtonDisabled}
                  data-hook="post-form__publish-button"
                >
                  {postId ? t('post-form.update') : t('post-form.publish')}
                </Button>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PostForm.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmitButtonClick: PropTypes.func.isRequired,
  borderWidth: PropTypes.number.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  limit: PropTypes.number,
  submitting: PropTypes.bool,
  invalid: PropTypes.bool,
  isMobile: PropTypes.bool,
  isDesktop: PropTypes.bool.isRequired,
  t: PropTypes.func,
  postId: PropTypes.string,
  categoryId: PropTypes.string,
  forPublicUser: PropTypes.func,
};

PostForm.defaultProps = {
  limit: 60,
};

export default _.flowRight(
  reduxForm(postFormSettings),
  withDeviceType,
  withTranslate,
  withCardBorderWidth,
  withFontClassName,
  withAuth,
)(PostForm);



// WEBPACK FOOTER //
// ./app/components/post-form/post-form.js